import Placeholder from '@tiptap/extension-placeholder';
import { getExtensionOption } from '../private/utils/getExtensionOption';

export const placeholderExtension = Placeholder.configure({
  placeholder: ({ node, editor, pos }) => {
    const defaultText = getExtensionOption(editor, 'placeholder');

    if (node.type.name === 'heading') return `Heading ${node.attrs.level}`;

    const nodeAtPos = editor.view.nodeDOM(pos) as Element;
    if (nodeAtPos?.closest?.('table')) return '';

    return defaultText;
  },
  includeChildren: true,
});
